var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "11px",
    viewBox: "0 0 13 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72A59669-7DFE-45FD-AAC8-B99907B8FB9D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety-Dashboard-Widgets",
    transform: "translate(-742.000000, -1381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(743.000000, 1144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gauge-gray",
    transform: "translate(0.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.01538462,
    y1: 8.87076923,
    x2: 2.18594739,
    y2: 8.3502475,
    id: "Line-2",
    stroke: "#878787",
    strokeWidth: 0.830769231,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.18604292,
    y1: 9.00882402,
    x2: 10.0562053,
    y2: 7.99857893,
    id: "Line-2",
    stroke: "#878787",
    strokeWidth: 0.830769231,
    strokeLinecap: "round",
    transform: "translate(9.621124, 8.503701) rotate(249.000000) translate(-9.621124, -8.503701) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.17672504,
    y1: 3.76912376,
    x2: 1.80218744,
    y2: 2.95626689,
    id: "Line-2",
    stroke: "#878787",
    strokeWidth: 0.830769231,
    strokeLinecap: "round",
    transform: "translate(1.489456, 3.362695) rotate(83.000000) translate(-1.489456, -3.362695) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.19098137,
    y1: 0.771283533,
    x2: 6.41257664,
    y2: 0.921276571,
    id: "Line-2",
    stroke: "#878787",
    strokeWidth: 0.830769231,
    strokeLinecap: "round",
    transform: "translate(5.801779, 0.846280) rotate(83.000000) translate(-5.801779, -0.846280) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.55360162,
    y1: 3.67423667,
    x2: 10.5546782,
    y2: 3.4511106,
    id: "Line-2",
    stroke: "#878787",
    strokeWidth: 0.830769231,
    strokeLinecap: "round",
    transform: "translate(10.054140, 3.562674) rotate(166.000000) translate(-10.054140, -3.562674) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.981058967,8.82096156 C0.36203905,7.91558046 -4.4408921e-15,6.82058242 -4.4408921e-15,5.64102564 C-4.4408921e-15,2.52557321 2.52557321,7.10542736e-15 5.64102564,7.10542736e-15 C8.75647808,7.10542736e-15 11.2820513,2.52557321 11.2820513,5.64102564 C11.2820513,6.78478742 10.9416518,7.84904464 10.356634,8.73801615",
    id: "Path",
    stroke: "#878787",
    strokeWidth: 0.923076923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36128103,1.76935697 L6.96399824,5.08621062 C7.10087224,5.31618201 7.17948718,5.58487079 7.17948718,5.87192108 C7.17948718,6.72158992 6.49069449,7.41038262 5.64102564,7.41038262 C4.7913568,7.41038262 4.1025641,6.72158992 4.1025641,5.87192108 C4.1025641,5.02225223 4.7913568,4.33345954 5.64102564,4.33345954 C5.6855321,4.33345954 5.72959716,4.33534942 5.77314494,4.33905332 L8.36128103,1.76935697 Z",
    id: "Combined-Shape",
    stroke: "#878787",
    strokeWidth: 0.738461538,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#878787",
    cx: 5.64102564,
    cy: 5.8974359,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeGray);
export default __webpack_public_path__ + "static/media/gauge-gray.03a1df9ec6737f96f7efa25d49846c75.svg";
export { ForwardRef as ReactComponent };